import { Badge, Loader, Stack } from "@mantine/core";

function colorForStatus(status) {
  switch (status.toLowerCase()) {
    case "waiting":
      return "yellow";
    case "queued":
    case "pre-queued":
    case "processing":
      return "blue";
    case "success":
      return "green";
    case "failed":
      return "red";
    default:
      return "blue";
  }
}

function nameForStatus(status) {
  switch (status.toLowerCase()) {
    case "waiting":
      return "Waiting";
    case "queued":
    case "processing":
    case "pre-queued":
      return "Processing";
    case "success":
      return "Success";
    case "failed":
      return "Failed";
  }
}

export default function ProcessingStatusBadge({ job }) {
  const status = (job?.status ?? "waiting").toLowerCase();
  return (
    <Stack align="center">
      <Badge color={colorForStatus(status)} size="lg">
        {nameForStatus(status)}
      </Badge>
      {(status == "processing" || status == "queued") && (
        <Loader color={colorForStatus(status)} type="bars" />
      )}
    </Stack>
  );
}
